// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__XOXIn","desc":"index_desc__UpgoE","title":"index_title___n_mb"};